import styled, { css } from "styled-components";
import { FooterLinkItemProps, InputProps } from "./FormModal.types";
import { pxToRem } from "styles/utils";

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;

export const ModalWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
`;

export const FormWrapper = styled.div`
  width: ${pxToRem(441)};
  max-width: calc(100vw - ${pxToRem(32)});
  padding: ${pxToRem(36)};
  border-radius: ${pxToRem(28.8)};
  text-align: center;
  box-sizing: border-box;
  border: ${pxToRem(1.2)} solid rgba(31, 10, 53, 0.1);
  box-shadow: ${pxToRem(2.4)} ${pxToRem(7.2)} ${pxToRem(34.8)} 0px rgba(0, 0, 0, 0.09);
  background: rgb(255, 255, 255);

  h2 {
    font-size: ${pxToRem(36)};
    font-weight: 600;
    margin: 0;
    margin-bottom: ${pxToRem(25.4)};
  }

  form > button {
    font-size: ${pxToRem(19.2)};
  }
`;

export const FieldWrapper = styled.div`
  margin-bottom: ${pxToRem(19.2)};
  text-align: left;
  display: flex;
  flex-direction: column-reverse;
  position: relative;
`;

export const Input = styled.input<InputProps>`
  width: 100%;
  height: ${({ height }) => pxToRem(height || 48)};
  padding: 0 ${pxToRem(19.2)};
  box-sizing: border-box;
  font-size: ${pxToRem(19.2)};
  line-height: 1.25;
  color: ${({ theme }) => theme.colors.ink};
  border-radius: ${pxToRem(12)};
  border: ${pxToRem(1.2)} solid rgba(31, 10, 53, 0.1);
  background: rgb(247, 248, 248);
  outline-width: 0;

  ${({ hasError }) =>
    hasError &&
    css`
      border: ${pxToRem(1.2)} solid rgb(242, 40, 98);
      background: rgba(114, 82, 220, 0.15);
    `}

  &:focus {
    border: ${pxToRem(1.2)} solid rgb(114, 82, 220);
    background: rgba(114, 82, 220, 0.15);
  }

  &:hover {
    border: ${pxToRem(1.2)} solid rgba(114, 82, 220, 0.1);
    background: rgba(114, 82, 220, 0.08);
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.inkMuted};
    opacity: 1;
  }
`;

export const ErrorMessage = styled.div`
  font-size: ${pxToRem(14.4)};
  color: #ff4d4d;
  margin-bottom: ${pxToRem(6)};
  position: sticky;
  left: ${pxToRem(19.2)};
  top: ${pxToRem(8.4)};
`;

export const FooterLinksWrapper = styled.div`
  margin-top: ${pxToRem(19.2)};
  display: flex;
  justify-content: space-between;
`;

export const FooterLinkItem = styled.a<FooterLinkItemProps>`
  font-size: ${pxToRem(16.8)};
  text-decoration: none;
  font-weight: 500;

  ${({ variant }) =>
    variant === "primary" &&
    css`
      color: rgb(134, 106, 229);
    `}

  ${({ variant }) =>
    variant === "secondary" &&
    css`
      color: rgba(31, 10, 53, 0.5);
    `}
`;

export const PasswordToggle = styled.button`
  position: absolute;
  right: ${pxToRem(12)};
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;

  &:hover {
    opacity: 0.8;
  }
`;

export const PasswordIcon = styled.svg`
  width: ${pxToRem(24)};
  height: ${pxToRem(24)};
  flex: 0 0 auto;
  margin-top: ${pxToRem(4.8)};
  margin-right: ${pxToRem(6)};
`;
